export default __webpack_public_path__ + "740f0c2f4370a05eb8e93fe0052d6d0e.jpg";